export const SOURCE_OPTIONS = [
    {label:'AWS S3', value: '1'},
    {label:'JMGEmailLink', value: '2'},
    {label:'Real Page', value: '3'},
    {label:'SFTP', value: '4'}
];
